import { stringify } from 'query-string';

import { entityTypeToApiType } from 'helpers/mapEntityTypes';

import { EntityTypes } from 'context/entityContext';
import getRegionBreakdown from 'helpers/getRegionBreakdown';
import getCountryIds from 'helpers/getCountryIds';

interface IPhysicalKPIURLArgs {
  countryIds?: string[] | string;
  download?: boolean;
  entityType: EntityTypes;
  entityIds: string[];
  region: string | undefined;
  compareMode?: string;
  customRegion?: string | string[];
}

export default function getPhysicalKPIURL(args: IPhysicalKPIURLArgs): string {
  const {
    countryIds,
    download,
    entityType,
    entityIds,
    region,
    compareMode,
    customRegion,
  } = args;
  const type = entityTypeToApiType(entityType);

  const params = stringify({
    countryIds: getCountryIds(countryIds, region, customRegion),
    download,
    regionBreakdown: getRegionBreakdown(
      countryIds,
      region,
      compareMode,
      customRegion
    ),
  });

  return `/api/physical/kpi/${type}/${entityIds}?${params}`;
}
